import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';
type TTrackingRecord = Record<string, any>;

interface IChannelBuilder {
  icon: string;
  desktopActionable: boolean;
  description: string;
  link: {
    desktop: string;
    android: string;
    ios: string;
  };
}

interface IHelpType {
  nk: string;
  channel: string;
  contact_label: string;
  contact_value: string;
  contact_display_value: string;
  rank: number;
  metadata: IChannelBuilder;
}

interface IHelpResources {
  nk: string;
  title: string;
  description: string;
  footer: string;
  details: IHelpType[];
}

interface IHelpResourcesTypeDef {
  type: string;
  typeDef: Record<
    string,
    {
      type: string;
      defaultValue?: string | IHelpType[];
    }
  >;
}

interface IApplicationConfigurationModel {
  member_features: Record<string, boolean>;
  member_configs: Record<string, string>;
  institution_media_paths: Record<string, string>;
  LOGIN_HELP: IHelpResources;
  ADVISING_HELP: IHelpResources;
  TECHNICAL_HELP: IHelpResources;
}

export interface IApplicationConfiguration {
  model: IApplicationConfigurationModel;
  AppConfigDTD: {
    member_features: string;
    institution_media_paths: string;
    member_configs: {
      type: string;
      typeDef: string;
    };
    LOGIN_HELP: IHelpResourcesTypeDef;
    ADVISING_HELP: IHelpResourcesTypeDef;
    TECHNICAL_HELP: IHelpResourcesTypeDef;
  };
  initialize: () => IApplicationConfigurationModel;
  update: (data: IApplicationConfigurationModel) => IApplicationConfigurationModel;
  isConfigLoaded: () => boolean;
  isFeatureEnabled: (key: string) => boolean;
  getConfigProperty: (key: string) => string;
  productName: () => string;
}

angular
  .module('capability-ng-academic-planner')
  .factory(
    'initializeUserActivityTrackingCommand',
    (
      accountModel: AccountModel,
      appConfigModel: IApplicationConfiguration,
      defineCommand: IDefineCommand
    ): ICommand => {
      return defineCommand(
        'initializeUserActivityTrackingCommand',
        function initializeUserActivityTrackingCommand(deferred: ng.IDeferred<IQuery[]>): void {
          try {
            const createUserTracking = (): TTrackingRecord => {
              // add an `id` to the visitor if the visitor is not FAKE, SuperUser, or Guest
              let visitorID = accountModel.gainsight_id || accountModel.tracking_id;
              const isFakeStudent = visitorID.indexOf('FAKE') >= 0;
              const isSuperUser = accountModel.isSuperuser;
              // TODO is not `is_guest`
              if (!isFakeStudent || !isSuperUser) {
                visitorID = accountModel.gainsight_id;
              }
              return {
                id: visitorID,
                firstName: accountModel.firstName,
                lastName: accountModel.lastName,
                email: accountModel.email,
                super_user: accountModel.isSuperuser,
                user_types: 'advisor',
                sgd_user_types: 'Staff',
                language: 'en_US',
                Device: 'Desktop'
              };
            };

            const getEnvironment = () => {
              const inURL = (url: string, s: string) => url.indexOf(s) >= 0;
              const searchParams = new URLSearchParams(window.location.search);
              const env = searchParams.get('env');
              if (!env) {
                return 'Prod';
              }
              return inURL(env, 'impl')
                ? 'Impl'
                : inURL(env, 'dev') || env.match(/\d+\.\d+\.\d+\.\d+/) !== null
                ? 'Dev'
                : inURL(env, 'sandbox') || inURL(env, 'demo') || inURL(env, 'realtime')
                ? 'Other'
                : 'Prod';
            };

            const createAccountTracking = (): TTrackingRecord => {
              return {
                id: accountModel.account_name,
                sgd_product: 'Smart Guidance',
                stc_product: 'Strategic Care',
                name: appConfigModel.getConfigProperty('core-inst_name'),
                has_ap: appConfigModel.isFeatureEnabled('ap3-academic_planner_v3'),
                has_registration: appConfigModel.isFeatureEnabled('reg-scheduler'),
                Environment: getEnvironment(),
                account_type: accountModel.account_type
              };
            };
            const initializeGainSightPX = (user: TTrackingRecord, account: TTrackingRecord) => {
              if ('aptrinsic' in window && _4.isFunction(window['aptrinsic'])) {
                window['aptrinsic']('identify', user, account);
                window['aptrinsic']('set', 'globalContext', { Device: user['Device'] });
              }
            };
            initializeGainSightPX(createUserTracking(), createAccountTracking());
          } finally {
            deferred.resolve();
          }
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/commands/initialize_user_activity_tracking_command.ts